<template>
  <div>
    <v-card class="pa-4 ma-3 main-card">
      <div class="my-1 mx-3">
        <div class="d-flex align-end">
          <div class="icon-back">
            <v-icon id="icon" size="37" color="white">
              mdi-chart-areaspline
            </v-icon>
          </div>

          <v-toolbar-title class="main-title">
            {{ $t('Cronograma') }}
          </v-toolbar-title>

          <div class="ml-6 color-container">
            <div class="d-flex align-end">
              <div class="executed-ondate-color"></div>
              {{ $t('Agendada') }}: {{ statistics.scheduled || 0 }}
            </div>
            <div class="d-flex align-end">
              <div class="schedule-color"></div>
              {{ $t('Executada dentro do prazo') }}:
              {{ statistics.executedInTime || 0 }}
            </div>
            <div class="d-flex align-end">
              <div class="executed-offdate-color"></div>
              {{ $t('Executada fora do prazo') }}:
              {{ statistics.executedLate || 0 }}
            </div>
            <div class="d-flex align-end">
              <div class="executed-outside-month-color"></div>
              {{ $t('Atrasada') }}: {{ statistics.late || 0 }}
            </div>
          </div>
        </div>
      </div>

      <v-simple-table class="mt-2 custom-table mx-3 mb-6" fixed-header>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Instituição</th>
              <th class="text-left">{{ $t('Identificação') }}</th>
              <th class="text-left">{{ $t('Patrimônio') }}</th>
              <th class="text-left">{{ $t('Nº Série') }}</th>
              <th class="text-left">{{ $t('Equipamento') }}</th>
              <th class="text-left">{{ $t('Fabricante') }}</th>
              <th class="text-left">{{ $t('Modelo') }}</th>
              <th class="text-left">{{ $t('Oficina') }}</th>
              <th class="text-left">{{ $t('Unidade') }}</th>
              <th class="text-left">{{ $t('Setor') }}</th>
              <th class="text-center">{{ $t('Tipo OS') }}</th>
              <th class="text-left">{{ $t('Resp.') }}</th>
              <th class="text-left">{{ $t('Responsável') }}</th>
              <th class="text-center">{{ $t('Jan') }}</th>
              <th class="text-center">{{ $t('Fev') }}</th>
              <th class="text-center">{{ $t('Mar') }}</th>
              <th class="text-center">{{ $t('Abr') }}</th>
              <th class="text-center">{{ $t('Mai') }}</th>
              <th class="text-center">{{ $t('Jun') }}</th>
              <th class="text-center">{{ $t('Jul') }}</th>
              <th class="text-center">{{ $t('Ago') }}</th>
              <th class="text-center">{{ $t('Set') }}</th>
              <th class="text-center">{{ $t('Out') }}</th>
              <th class="text-center">{{ $t('Nov') }}</th>
              <th class="text-center">{{ $t('Dez') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in rows" :key="index">
              <td>{{ item.institution }}</td>
              <td>
                {{ item.identification }}
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      text
                      color="#0F3565"
                      :href="
                        item.openOrderId
                          ? `/editServiceOrder/${item.openOrderId}`
                          : ''
                      "
                      target="_blank"
                      v-bind="attrs"
                      v-on="on"
                      v-if="item.openOrderId"
                    >
                      <v-icon> mdi-exclamation-thick </v-icon>
                    </v-btn>
                  </template>
                  <span>Em manutenção corretiva! Clique para acessar</span>
                </v-tooltip>
              </td>
              <td>{{ item.propertyCode }}</td>
              <td>{{ item.serialNumber }}</td>
              <td>{{ item.equipmentName }}</td>
              <td>{{ item.manufacturer }}</td>
              <td>{{ item.model }}</td>
              <td>{{ item.workshop }}</td>
              <td>{{ item.unidade }}</td>
              <td>{{ item.departmentName }}</td>
              <td class="text-center">{{ $t(item.serviceOrderType) }}</td>
              <td class="text-lef">{{ $t(item.responsability) }}</td>
              <td class="text-left">{{ item.responsible }}</td>
              <td class="text-center" v-for="month in 12" :key="month">
                <template v-if="getMonthData(item, month).length">
                  <v-btn
                    v-if="getMonthData(item, month).length === 1"
                    height="41"
                    small
                    depressed
                    :color="
                      getMonthData(item, month)[0].backgroundColor ||
                      'transparent'
                    "
                    :href="
                      getMonthUrl(item, month, getMonthData(item, month)[0])
                    "
                    target="_blank"
                  >
                    {{ getMonthData(item, month)[0].displayDate }}
                  </v-btn>
                  <v-btn
                    v-else
                    height="41"
                    small
                    depressed
                    color="#FFD21F"
                    :href="getMonthListUrl(item, month)"
                    target="_blank"
                  >
                    {{ getMonthData(item, month)[0].displayDate }}
                    +
                  </v-btn>
                </template>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
import ApiService from '../../../services/ApiService'
export default {
  name: 'Schedule',
  created() {
    const filters = JSON.parse(localStorage.getItem('scheduleFilters'))
    this.list(filters)
  },
  mounted() {
    setTimeout(() => {
      const slider = document.querySelector(
        '.custom-table .v-data-table__wrapper'
      )
      let isDown = false
      let startX
      let scrollLeft
      slider.addEventListener('mousedown', (e) => {
        isDown = true
        slider.classList.add('active')
        startX = e.pageX - slider.offsetLeft
        scrollLeft = slider.scrollLeft
      })
      slider.addEventListener('mouseleave', () => {
        isDown = false
        slider.classList.remove('active')
      })
      slider.addEventListener('mouseup', () => {
        isDown = false
        slider.classList.remove('active')
      })
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return
        e.preventDefault()
        const x = e.pageX - slider.offsetLeft
        const walk = (x - startX) * 3
        slider.scrollLeft = scrollLeft - walk
      })
    }, 2000)
  },
  data() {
    return {
      statistics: {},
      apiService: new ApiService(),
      rows: [],
      year: null,
    }
  },
  methods: {
    getMonthData(item, month) {
      const m = item.monthlyData.find((x) => x.month === month)
      return m ? m.serviceOrders : []
    },
    getMonthUrl(item, month, order) {
      if (order.isPlanning) {
        if (item.planningOSInfo) {
          localStorage.setItem(
            `planningOSInfo-${order.id}`,
            JSON.stringify(item.planningOSInfo)
          )
        } else {
          localStorage.setItem(
            `planningOSInfo-${order.id}`,
            JSON.stringify({ responsability: item.responsability })
          )
        }
        return `/newServiceOrder?equipmentId=${item.equipmentId}&month=${month}&year=${this.year}&type=${item.serviceOrderType}&fromPlanning=true&scheduledDate=${order.date}&planningId=${order.id}`
      }
      return `/editServiceOrder/${order.id}`
    },
    getMonthListUrl(item, month) {
      return `/listServiceOrders?equipment=${item.equipmentId}&month=${month}&year=${this.year}&type=${item.serviceOrderType}`
    },
    async list(filters) {
      await this.apiService
        .post('Chronogram', filters)
        .then((response) => {
          const content = response.content
          this.rows = content.rows
          this.year = content.year
          this.statistics = content.statistics
        })
        .catch(() => {})
    },
  },
}
</script>

<style>
.v-data-table__wrapper::-webkit-scrollbar {
  background-color: #fff !important;
  opacity: 0.6 !important;
  height: 35px;
  width: 35px;
}

.v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: #ccc !important;
  opacity: 0.8 !important;
  border: 14px solid #fff !important;
  height: 5px !important;
  border-radius: 20px;
}

.v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #888 !important;
  opacity: 0.6 !important;
}
</style>

<style scoped>
.schedule-color,
.executed-ondate-color,
.executed-offdate-color,
.executed-outside-month-color {
  width: 60px;
  height: 20px;
  padding: 6px;
  margin: 1px 6px;
  border: 2px solid #ccc;
  border-radius: 4px;
}

.color-container {
  font-size: 12px;
  font-weight: 700;
}

.schedule-color {
  background: #b9ce1e;
}

.executed-ondate-color {
  background: #ffd21f;
}

.executed-offdate-color {
  background: #3c8ea6;
}

.executed-outside-month-color {
  background: #ff4f64;
}

.custom-table thead tr th {
  padding-left: 16px !important;
  background: #2a8ea4 !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 16px !important;
  color: #ffffff !important;
  min-width: 90px;
}

.custom-table thead tr th:first-child {
  border-radius: 4px 0 0 4px !important;
}

.custom-table thead tr th:last-child {
  padding-right: 16px !important;
  border-radius: 0 4px 4px 0 !important;
}

.custom-table tbody tr td:last-child {
  padding-right: 16px !important;
  border-radius: 0 4px 4px 0 !important;
}

.custom-table tbody tr td {
  padding: 4px 0 4px 14px !important;
  font-weight: 300 !important;
  font-size: 12px !important;
  line-height: 15px !important;
  letter-spacing: 0.15px !important;
  color: #808080 !important;
}

.custom-table tbody tr td .v-btn {
  color: #202020 !important;
}

.main-card {
  z-index: 16 !important;
  background: #ffffff;
  box-shadow: 0px 5px 16px rgba(0, 0, 0, 0.05) !important;
  border-radius: 8px;
}

.icon-back {
  width: 60px;
  height: 54px;
  background: #b9ce1e;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-title {
  margin-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;

  color: #000000;
}
</style>
